// extracted by mini-css-extract-plugin
export default {"InvalidFieldsTable":"InvalidFields-module-fc7013461decfe9d4128"};